import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from "@/mixins/infoList";
import { getOperationRecord, getScreenList } from "@/api/authority";
export default {
  name: "index",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getOperationRecord,
      typeList: {},
      operatorList: {},
      zeroTime: null,
      currentTime: null,
      Operator: '',
      Type: ''
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.getParameter();
            _context.next = 1;
            return _this.initparamete();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    initparamete: function initparamete() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.Type = -1;
              _this2.searchInfo.Operator = -1;
              _context2.next = 1;
              return _this2.getTableData();
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getParameter: function getParameter() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var parameter;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return getScreenList();
            case 1:
              parameter = _context3.sent;
              if (parameter.code == 0) {
                _this3.typeList = parameter.data.typeList;
                _this3.operatorList = parameter.data.operatorList;
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};